import { render, staticRenderFns } from "./Cta.vue?vue&type=template&id=4cef4905&scoped=true"
import script from "./Cta.vue?vue&type=script&lang=js"
export * from "./Cta.vue?vue&type=script&lang=js"
import style0 from "./Cta.vue?vue&type=style&index=0&id=4cef4905&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cef4905",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cef4905')) {
      api.createRecord('4cef4905', component.options)
    } else {
      api.reload('4cef4905', component.options)
    }
    module.hot.accept("./Cta.vue?vue&type=template&id=4cef4905&scoped=true", function () {
      api.rerender('4cef4905', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Cta.vue"
export default component.exports